import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import { Button, Container, ListItemAvatar } from '@material-ui/core';
import Page from 'src/components/Page';
import Results from 'src/components/Results';
import Header from './Header';
import moment from 'moment';
import gradients from 'src/utils/gradients';
import { avatars } from 'src/components/NotificationsPopover/NotificationList';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  },
  colorBox: {
    width: 60,
    height: 30
  },
  avatarBlue: {
    backgroundImage: gradients.blue
  },
  avatarGreen: {
    backgroundImage: gradients.green
  },
  avatarOrange: {
    backgroundImage: gradients.orange
  },
  avatarIndigo: {
    backgroundImage: gradients.indigo
  },
  nameItems: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const GET_NOTIFICATIONS = gql`
  query GetNotifications($page: Page) {
    adminNotifications(page: $page) {
      edges {
        event
        createdAt
        classroomInstance {
          uuid
        }
      }
      pageInfo {
        total
        offset
        limit
        given
      }
    }
  }
`;

export const notificationTitle = {
  CLASSROOM_BOOKING: {
    title: 'New classroom booking',
    type: 'order'
  },
  COMPANY_REQUEST: {
    title: 'New company request',
    type: 'user'
  }
};

export const notificationOnClick = (notification, history) => {
  switch (notification.event) {
    case 'COMPANY_REQUEST':
      history.push('/approve-companies');
      break;
    case 'CLASSROOM_BOOKING':
      history.push(`/instance/${notification.classroomInstance.uuid}`);
      break;
    default:
      break;
  }
};

function Notifications() {
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const history = useHistory();
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { error, data } = useQuery(GET_NOTIFICATIONS, {
    variables: {
      page: {
        offset: page * rowsPerPage,
        limit: rowsPerPage
      }
    },
    fetchPolicy: 'cache-and-network'
  });

  if (error) return <div>{error.message}</div>;

  // Results methods
  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  // Results table
  const headers = ['Name', 'Time', 'Actions'];
  const cells = [
    {
      component: result => (
        <div className={classes.nameItems}>
          <ListItemAvatar>
            {avatars(classes)[notificationTitle[result.event].type]}
          </ListItemAvatar>
          {notificationTitle[result.event].title}
        </div>
      )
    },
    {
      component: result => <div>{moment(result.createdAt).fromNow()}</div>
    },
    {
      component: result => (
        <Button
          variant={'outlined'}
          size="small"
          color="primary"
          onClick={() => notificationOnClick(result, history)}
        >
          View
        </Button>
      )
    }
  ];

  return (
    <Page className={classes.root} title="Notifications">
      <Container maxWidth={false}>
        <Header />
        <Results
          className={classes.results}
          results={data?.adminNotifications}
          headers={headers}
          cells={cells}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Container>
    </Page>
  );
}

export default Notifications;
